import { module as BaseModule } from 'modujs'
import { load } from 'recaptcha-v3'
import { i18 } from '../utils/dom'

export default class extends BaseModule {
  init() {
    this.notice = this.el.querySelector('[data-contact-form-notice]')
    this.button = this.el.querySelector('button')
    this.isSending = false
    this.isSent = false

    this.notice.addEventListener('click', () => {
      this.notice.classList.add('hidden')
    })

    this.el.addEventListener('submit', async (e) => {
      e.preventDefault()
      if (this.isSending || this.isSent) return

      this.verify()
    })
  }

  async verify() {
    this.isSending = false

    const recaptcha = await load('6Ld8NSApAAAAAO_mHu5W9mHj3StsmPt6YOt35XTL')
    const token = await recaptcha.execute('contactForm')

    try {
      const request = await fetch('/wp-json/custom/v1/recaptcha', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
        }),
      })

      const response = await request.json()
      const { status } = request
      const { message } = response

      if (status === 200) {
        this.notice.classList.add('hidden')
        this.send()
        return
      }

      this.notice.classList.remove('hidden')
      this.notice.innerHTML = message
      this.button.innerHTML = 'Envoyer'
      this.isSending = false
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async send() {
    this.isSending = true

    const formData = new FormData(this.el)

    const data = {}
    const formDataArray = Array.from(formData)
    formDataArray.forEach(([key, value]) => {
      data[key] = value
    })

    this.button.innerHTML = i18('Envoi en cours..', 'Sending..', 'Senden..')

    const request = await fetch('/wp-json/custom/v1/contact-form', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    const response = await request.json()
    const { status } = request
    const { message } = response

    if (status === 200) {
      this.button.innerHTML = message
      this.isSent = true
    } else {
      this.notice.classList.remove('hidden')
      this.notice.innerHTML = message
      this.button.innerHTML = i18('Envoyer', 'Send', 'Senden')
      this.isSending = false
    }
  }
}
